export const configuration = {
  urls: {
    discoveryPagesService: process.env.DISCOVERY_PAGES_SERVICE_URL
  },
  requestor: 'dp-mappings-ui-extension'
};
